import styled from 'styled-components';
import CustomBlockButton from '../../../../../components/button/CustomBlockButton';
import { useNavigate } from 'react-router-dom';
import { useQueryParamsHook } from '../../../../../utils/useQueryParamsHook';
import { useCollectedOrderDatasActionsContextHook, useCollectedOrderDatasValueContextHook } from '../../contexts/CollectedOrderDatasContext';
import { useApiInfoContextValueHook } from '../../../../../contexts/ApiInfoContext';
import { customToast } from '../../../../../components/toast/custom-react-toastify/v1';
import { SellertoolSignatureUtils } from '../../../../../utils/sellertool-signature-utils';
import { CustomBackdropController } from '../../../../../components/backdrop/default/v1';
import { useSelectedCoupangApiStoreInfosValueContextHook } from '../../contexts/SelectedCoupangApiStoreInfosContext';
import { useSelectedCollectedOrderDataActionsContextHook } from '../../contexts/SelectedCollectedOrderDataContext';
import { CoupangApiApi } from '../../../../../apis/CoupangApiApi';

const SidebarContainer = styled.div`
  width: 250px;
  min-height: 100vh;
  background-color: #f8f9fa;
  border-right: 1px solid #e0e0e0;
  padding: 20px 0;
  overflow-y: auto;
`

const SidebarTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin: 0 0 20px;
  padding: 0 20px;
`

const ReFetchButton = {
  Container: styled.div`
    padding: 0px 20px;
    margin-bottom: 20px;
  `,
  Button: styled(CustomBlockButton)`
    background-color: #333;
    color: #fff;
    font-weight: 600;
    border-radius: 3px;
  `
}

const SidebarList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
`

const SidebarItem = styled.li`
  padding: 10px 20px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #e9ecef;
  }
`

const ItemName = styled.span`
  font-size: 16px;
  color: #495057;
`

const ItemCount = styled.span`
  float: right;
  background-color: #6c757d;
  color: white;
  border-radius: 12px;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 600;
`

const WegetCollectedSidebar = ({ items }) => {
  const navigate = useNavigate();
  const queryParamsHook = useQueryParamsHook();
  const collectedOrderDatasValueContextHook = useCollectedOrderDatasValueContextHook();
  const collectedOrderDatasActionsContextHook = useCollectedOrderDatasActionsContextHook();
  const selectedCoupangApiStoreInfosValueContextHook = useSelectedCoupangApiStoreInfosValueContextHook();
  const selectedCollectedOrderDataActionsContextHook = useSelectedCollectedOrderDataActionsContextHook();

  const apiInfoContextValueHook = useApiInfoContextValueHook();

  const handleFulfillCollection = async () => {
    if (selectedCoupangApiStoreInfosValueContextHook.coupangApiStoreInfos?.length <= 0) {
      customToast.error('주문수집에 문제가 발생했습니다. 처음부터 다시 시도해 주세요.');
      return;
    }

    const timestamp = Date.now().toString();
    const signature = SellertoolSignatureUtils().generateSigniture({
      apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
      secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
      timestamp: timestamp
    })

    const headers = {
      'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
      'x-sellertool-timestamp': timestamp,
      'x-sellertool-signiture': signature
    }

    const body = {
      coupangApiStoreInfoIds: selectedCoupangApiStoreInfosValueContextHook.coupangApiStoreInfos.map(storeInfo => storeInfo.id)
    }

    CustomBackdropController().showBackdrop();
    const result = await CoupangApiApi().collectOrders({ body: body, headers: headers });
    if (!result?.content) {
      customToast.error('주문수집에 문제가 발생했습니다. 처음부터 다시 시도해 주세요.');
      return;
    }
    if (result?.content) {
      collectedOrderDatasActionsContextHook.collectedOrderDatas.onSet(result?.content);
    }
    CustomBackdropController().hideBackdrop();
  }

  return (
    <SidebarContainer>
      <SidebarTitle>수집 스토어 리스트</SidebarTitle>
      <ReFetchButton.Container>
        <ReFetchButton.Button
          type='button'
          onClick={() => handleFulfillCollection()}
        >재조회</ReFetchButton.Button>
      </ReFetchButton.Container>
      <SidebarList>
        {collectedOrderDatasValueContextHook.collectedOrderDatas.map((collectionOrderData, index) => (
          <SidebarItem key={index} onClick={() => selectedCollectedOrderDataActionsContextHook?.selectedCollectedOrderData?.onSet(collectionOrderData)}>
            <ItemName>{collectionOrderData?.coupangApiStoreInfo.storeName}</ItemName>
            <ItemCount>{collectionOrderData?.newOrders?.length}</ItemCount>
          </SidebarItem>
        ))}
      </SidebarList>
    </SidebarContainer>
  )
}

export default WegetCollectedSidebar

